import "core-js/modules/es6.string.link";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { imgOption } from '@/option/config';
export default {
  data: function data() {
    return {
      imgVisible: false,
      imgObj: '',
      type: '',
      imgActive: 0,
      imgOption: imgOption,
      imgTabs: []
    };
  },
  computed: {
    styleName: function styleName() {
      if (this.type === 'background') {
        return {
          width: '200px'
        };
      }

      return {};
    }
  },
  watch: {
    type: {
      handler: function handler() {
        if (this.type === 'background') {
          this.imgActive = 0;
        } else if (this.type == 'border') {
          this.imgActive = 1;
        } else {
          this.imgActive = 2;
        }
      },
      immediate: true
    }
  },
  methods: {
    onSuccess: function onSuccess(res) {
      var url = res.data.link;
      this.imgOption[this.imgActive].unshift({
        label: url,
        value: url
      });
    },
    openImg: function openImg(item, type) {
      this.type = type;
      this.imgObj = item;
      this.imgVisible = true;
    },
    handleSetimg: function handleSetimg(item) {
      this.imgVisible = false;
      this.$emit('change', item, this.imgObj);
    }
  }
};